import { Ref, watch } from 'vue';
import { SelectCommonProps, SelectOption } from './types';
import { racePromises } from 'src/utils/promise';
import _ from 'lodash';

export function useSelectUtils<T>(
  props: SelectCommonProps<T>,
  filteredOptions: Ref<SelectOption<T>[]>,
  filter: Ref<string>,
  totalCount: Ref<number>,
  loading: Ref<boolean>,
  error: Ref<boolean>
) {
  watch(filter, async (value) => {
    if (props?.filteringDisabled) return;
    if (props.asyncFilterFunction) {
      const promise = props
        .asyncFilterFunction(value)
        .then((lazyFilterResponse) => {
          if (lazyFilterResponse.status) {
            error.value = false;
            totalCount.value = lazyFilterResponse.totalCount;
            filteredOptions.value = lazyFilterResponse.items;
          } else {
            filteredOptions.value = [];
            totalCount.value = 0;
            error.value = true;
          }
        });
      await racePromises(loading, 300, [promise]);
    } else if (props.filterFunction) {
      filteredOptions.value = props.filterFunction(value);
    } else {
      filteredOptions.value = _.filter(props.options, (option) =>
        option.label.toLowerCase().includes(value.toLowerCase())
      );
    }
  });

  let isFetching = false;
  const virtualLazyLoad = async (event) => {
    if (filteredOptions.value.length >= totalCount.value) return;
    if (isFetching) return;
    const page = Math.floor(
      filteredOptions.value.length / props.virtualScrollerOptions?.step
    );
    isFetching = true;
    lazyFetchData(event, page).then(() => {
      isFetching = false;
    });
  };

  async function lazyFetchData(event: any = {}, page = 0) {
    loading.value = true;
    await props.virtualScrollerOptions
      ?.onLazyLoad?.(
        event,
        filter.value,
        page,
        props.virtualScrollerOptions?.step
      )
      .then((response) => {
        if (response?.status) {
          error.value = false;
          totalCount.value = response.totalCount;
          if (page == 0) {
            filteredOptions.value = response.items;
          } else {
            filteredOptions.value.push(...response.items);
          }
        } else {
          filteredOptions.value = [];
          error.value = true;
        }
        loading.value = false;
      });
    // await racePromises(loading, 300, [promise]);
  }

  return {
    virtualLazyLoad,
    lazyFetchData,
  };
}
